import Vue from 'vue'
import commons from '@/util/commons.js'; // 引入通用函数

//图片
Vue.filter('toImgPath',(val)=>{
	return process.env.IMAGE_URL+val;
});
Vue.filter('isDefault',(val,str)=>{
	if(val=='' || val==null){
		return str;
	}else{
		return val;
	}
});

//制作面板 - Maketupian.vue  预览
Vue.filter('toMaketupianBack',(path,pathSize,ratio,start,imgBoxSize,type)=>{
	if(pathSize!=null && ratio!=null && imgBoxSize!=null){
			let imgHost = process.env.IMAGE_URL;//图片域名
			let imgStyle = process.env.IMAGE_URL_STYLE_PC;//图片样式
			//获取图片容器的CSS
			// 1图片地址 2图片宽高 3容器比列 4图片显示起始点 5图片容器的宽
			if(type==1){
				return commons.makeTupianBoxStyle(path,pathSize,ratio,start,imgBoxSize,imgHost,imgStyle);
			}else{
				return commons.makeMobileTupianBoxStyle(path,pathSize,ratio,start,imgBoxSize,imgHost,imgStyle);
			}
	}else{
		return {};
	}
});

//制作面板 - Maketupian.vue  闲置图片队列
Vue.filter('toMaketupianLeave',(path)=>{
	let imgHost = process.env.IMAGE_URL;//图片域名
	let imgStyle = process.env.IMAGE_URL_STYLE_LEAVE;//图片样式
	return imgHost+path+imgStyle;
});

//制作面板 - Maketupian.vue  闲置图片队列
Vue.filter('toMaketupianQrcode',(path)=>{
	let imgHost = process.env.IMAGE_URL;//图片域名
	let imgStyle = process.env.IMAGE_URL_STYLE_PC;//图片样式
	return imgHost+path+imgStyle;
});

//我的订单
Vue.filter('orderState',(type)=>{
	if(type==1){
		return '砍价中';
	}else if(type==2){
		return '待付款';
	}else if(type==3){
		return '待确认';
	}else if(type==4){
		return '印刷中';
	}else if(type==5){
		return '已发货';
	}else if(type==6){
		return '已完成';
	}else if(type==7){
		return '已取消';
	}else if(type==8){
		return '已退款';
	}else{
		return '未知错误';
	}
});



// WEBPACK FOOTER //
// ./src/util/filters.js